export default __webpack_public_path__ + "static/develop4u-0fb09cc3f26715a206b1234ad8d3b987.png";